import { DatiAggiuntivi } from "./datiAggiuntivi.model";
import { VATRateDTO } from "./VATRate.model";
import { CompanyAddingProperties, CompanyDTO, CompanyListDTO } from "./company.model";
import { DocumentLineDTO } from "./documentLine.model";
import { LookupDTO } from "./lookup.model";
import { DueInvoiceDTO } from "./dueInvoice.model";
import { AdvanceExpensesObject } from "./advanceExpensesObject.model";
import { ReceiptDTO, STSSendingResponseEnum } from "./receipt.model";
import { SocialSecurityContributionsDTO } from "./socialSecurityContributions.model";

/**
 * Modello per memorizzare i dati della fattura
 */
export class DocumentDTO {
  public ID: number;
  public Identifier: number;
  public InvoiceDate: Date;
  public FK_Company: number;
  public CompanyAddingProperties: CompanyAddingProperties;
  public Company: CompanyDTO;
  public FK_User: string;
  public StableOrganization: LookupDTO;
  public DocumentNote: LookupDTO;
  public Customer: LookupDTO;
  public DocumentType: LookupDTO;
  public DocumentProfile: LookupDTO;  
  public Section: string;
  public Currency: string;
  public Note: string;
  public CustomerNote: string;
  public PickupTime: string;
  public Bank: string;
  public ABI: string;
  public CAB: string;
  public PaymentTypeDescription: string;
  public CreatedDate: Date;
  public isSimplified: boolean;
  public IsClosed: boolean;
  public ManualExpires: boolean;
  public IsPassive: boolean;
  public isImportedXLSX: boolean;
  public TotalGrossDiscount: boolean;
  public TotalInvoice: number;
  public TotalVAT: number;
  public TotalTaxable: number;
  public TotalLine: number;
  public Total: number;
  public TotalManual: number;
  public DiscountAmount: number;
  public DiscountPercentage: number;
  public DiscountType: string;
  public StampCharge: boolean;
  public DocumentLines: Array<DocumentLineDTO>;
  public FK_DocumentTemplate: number;
  public VatRate: LookupDTO;
  public TotalPrepaidExpenses: number;
  public TotalCompetencies: number;
  public TotalEnasarcoManual: number;
  public Enasarco: number;
  public TotalEnasarco: number;
  public TotalWithholdingTax: number;
  public WithholdingTax: number;
  public Cicp: number;
  public BuyerTransferee: CompanyListDTO;
  public VATGrid: Array<VATGrid>;
  public DueInvoices: Array<DueInvoiceDTO>;
  public Receipts: Array<ReceiptDTO>;
  public AdvanceExpenses: AdvanceExpensesObject;
  public SocialSecurityContributions: SocialSecurityContributionsDTO[];
  public TotalFreight: number;
  public TotalExpenses: number;
  public SdiFEResult: string;
  public ResidualAmount: number;
  public CustomerObj: string;
  public RifAmmFE: string;
  public PaymentCondition: LookupDTO;
  public Rounding: number;
  public TotalStamp: number;
  public isNewParcella: boolean;

  //Proprietà solo client per il totale dell'importo da assegnare
  public DueInvoiceAmountToAssigne: number;

  public DatiAggiuntivi: DatiAggiuntivi;

  // PROPRIETA' PER CALCOLO TOTALI
  public Split: boolean;
  public IsPA: boolean;
  public EnasarcoPercentage: number;
  public CicpPercentage: number;
  public WithholdingTaxPercentage: number;
  public TotalVATPercentage: number;
  public SocialSecurityWithholdingCashDesk: boolean;
  public IsVATSeparation: boolean;

  public IdentifierXML: string;

  //Proprietà per il trasporto
  public CustomerCarrier: LookupDTO;

  // Identifica il mezzo di trasporto
  public TransportVehicle: string;

  // Vettore
  public Carrier: string;

  // Vettore conducente
  public CarrierDriver: string;

  // Causale trasporto
  public TransportCausal: string;

  // Campo attualmente non utilizzato
  public TransportCausal1: string;

  // Numero colli
  public BaggageItem: string;

  // Peso Lordo della merce
  public Weight: string;

  // Peso netto della merce
  public NetWeight: string;

  // Unità di misura del peso
  public WeightUnit: string;

  // Data ritiro
  public PickupDate: Date;

  // Data e ora di consegna
  public DeliveryDate: Date;

  //Data inizio trasporto
  public StartTransportDate: Date;

  // Aspetto esteriore dei beni (finisce nel nodo 2.1.9.5 dell'XML)
  public Aspect: string;

  // Descrizione presente nei dati di trasporto
  public TransportDescription: string;

  // Mittente
  public Sender: string;

  // Destinatario
  public Addressee: string;

  // Costi trasporto
  public TransportCosts: number;

  // Costi di imballaggio
  public PackagingCosts: number;

  // Tipo resa (identifica i termini del trasporto e usa una codifica ministeriale)
  public TransportTerm: string;

  // Identifica il luogo di destinazione per la consegna (nodo XML 2.1.9.12.1)
  public Site: string;

  // Attualmente non utilizzato
  public Site1: string;

  // Attualmente non utilizzato
  public Site2: string;

  // NUmero civico del luogo di destinazione
  public SiteNumber: string;

  // CAP del luogo di destinazione
  public SiteCap: string;

  // COmune del luogo di destinazione
  public SiteDistrict: string;

  // Provincia del luogo di destinazione
  public SiteProvince: string;

  // Nazione del luogo di destinazione
  public SiteCountry: string;

  // Indirizzo del luogo di destinazione
  public SiteName: string;

  // Proprietà solo client per la visualizzazione dell'indirizzo
  public SiteSummary: string;

  //Proprietà per la gestione dell'automatismo del bollo
  public StampAutomatismEnabled: boolean;

  //Periodo di fatturazione 
  public PeriodInvoiceDateStart: Date;
  public PeriodInvoiceDateEnd: Date;

  public OrderReferencePurchase :string;
  public OrderReferenceSales: string;
  // Gestione AFNOR Flow Service
  public CurrentCDVCode: string;
  public CurrentCDVLabel: string; 
  public CurrentCDVPhase: string;
  public CurrentInvoiceFlowId: string;
  public CurrentTrackingId: string;
  public isReadOnly: boolean;
}

export class DocumentListDTO {
  public ID: number;
  public Section: string;
  public Identifier: number;
  public InvoiceDate: Date;
  public FK_Company: number;
  public FK_User: string;
  public Customer: string;
  public CodeType: string;  
  public DocumentType: string;
  public DocumentProfileDes: string;  
  public SdiFEResult: string;
  public TotalInvoice: number;
  public TotalVAT: number;
  public TotalTaxable: number;
  public ResidualAmount: number;
  public hasAttachments: boolean;
  public hasSDIResponse: boolean;
  public IdSdiFE: string;
  public idSDIStatoConservazione: number;
  public hasReceipts: boolean;
  public FK_CommercialLevel: number;
  public FK_DocumentTemplate: number;
  public FK_Customer: number;
  public IsDisabled: boolean;  
  // Gestione AFNOR Flow Service
  public CurrentCDVCode: string;
  public CurrentCDVLabel: string;
  public CurrentCDVPhase: string;
  public CurrentInvoiceFlowId: string;
  public CurrentTrackingId: string;
  public isReadOnly: boolean;
}

export class DocumentParameterDTO {
  public Identifier: number;
  public Section: string;
  public FK_DocumentTemplate: number;
  public FK_Company: number;
  public InvoiceDate: Date;
  public IsPassiveCycle: boolean;
  public IsSequentialIdentifier: boolean;
  public IsProforma: boolean;  
  public FK_DocumentType: number;
  public ID: number;
}

export class VATGrid {
  public VatRate: VATRateDTO;
  public TaxableAmount: number;
  public VATAmount: number;
  public VATExpensesAmount: number;
  public ExpensesAmount: number;
}

export class CashFlowDetailDTO {
  public ID: number;
  public Identifier: number;  
  public InvoiceDate: Date;
  public ResidualAmount: number;
  public DueInvoices: DueInvoiceDTO[];
  public Receipts: ReceiptDTO[];
  public ExternalIdentifier: string;
  public Section: string;
  public DocumentType: LookupDTO;  
  public STSTipoInvio: STSTipoInvioEnum;
}
//SOLO CLIENT
export class DocumentTotals {
  public TotalTaxable: number;
  public TotalDocument: number;
  public TotalVAT: number;
  public TotalCashOut: number;
  public TotalNetToPay: number;
}

export class Data {
  public name: string;
  public value: number;
}

export class SDIUpdateDTO {
  public ID: number;
  public ReceptionDate: Date;
  public IDSDI: string;
}

export enum DocumentTemplateEnum {
  FATTURA_DI_VENDITA = 15,
  FATTURA_ACCOMPAGNATORIA = 14,
  FATTURA_AGENTE = 16,
  PARCELLA = 4,
  FATTURA_SEMPLIFICATA = 18
}

export enum UpdateDocumentResult {
  DAYS_ALL = 1,
  DAYS_30 = 30
}

export enum STSTipoInvioEnum {
  INSERIMENTO = 0,
  VARIAZIONE = 1,
  CANCELLAZIONE=2,
  RIMBORSO=3
}

export const BOLLO_SOGLIA :number = 77.47;

export enum LookupIndex {
  DocumentType,
  Product,  
  VatRate,
  TransportTerms,
  SubjectTo,
  CashDeskType,
  Nature,
  Currencies,
  WithHoldingType,
  DocumentProfile,
  DocumentNote,
  StableOrganization,
  ProfileID,
  OptionTVA
}
   